export const environment = {
  production: true,
  apiBase: 'https://noisypodcaster.wahl.website',
  siteName: 'Noisy Podcaster',
  companyName: 'Noisy Podcaster',
  businessAddress: '',
  supportEmail: 'noisythangs@gmail.com',
  supportPhone: '',
  ageGateEnabled: false,
  coppaMode: false,
  privacyEffectiveDate: 'January 1, 2026',
  termsEffectiveDate: 'January 1, 2026',
  cookieEffectiveDate: 'January 1, 2026',
  dmcaAgentName: '',
  dmcaAgentEmail: '',
  dmcaAgentAddress: '',
  analyticsProvider: '',
};
